export const configDefaults = {
  walkthroughEnabledStg: true,
  walkthroughEnabledPrd: true,
  givingButtonEnabled: true,
  givingEnabledPrd: true,
  givingEnabledStg: true,
  learningRemindersStg: false,
  learningRemindersPrd: false,
};
